module.exports = __webpack_public_path__ + "images/FUSA_icons/057-shop.96e48f5518b64798384de1857f3faf66.svg";